import React from "react";
import logodark from "../assest/logo-dark.png";
import kyc from "../assest/kyc-logo.png";

const KycSuccess = () => {
  return (
    <div className="bg-screen d-flex align-items-center justify-content-center">
      <div className="text-center">
        {/* Logo */}
        <img
          src={logodark}
          alt="Logo"
          className="mb-4"
          style={{ width: "120px" }}
        />
        {/* KYC Verified Icon */}
        <div className="mb-3">
          <img src={kyc} alt="Logo" />
        </div>

        {/* Title */}
        <h5 className="">KYC Verification</h5>
        <h4 className="">Successfully Completed</h4>

        {/* Message */}
        <p className="">Your identity has been verified successfully.</p>
        <p className="">
          You now have full access to all platform features and services.
        </p>
      </div>
    </div>
  );
};

export default KycSuccess;
